export default __webpack_public_path__ + "static/media/shopifyNativeConcent1.e3818b51.svg";